'use client';
import React, { useState, useEffect } from 'react';

export const localData = {
    set(key, value) {
        try {
            if (typeof window !== 'undefined') {
                localStorage.setItem(key, JSON.stringify(value));
            }
        } catch (error) {
            console.warn('Error setting localStorage:', error);
        }
    },
    get(key) {
        try {
            if (typeof window !== 'undefined') {
                const stored = localStorage.getItem(key);
                return stored == null ? undefined : JSON.parse(stored);
            }
            return undefined;
        } catch (error) {
            console.warn('Error getting localStorage:', error);
            return undefined;
        }
    },
    remove(key) {
        try {
            if (typeof window !== 'undefined') {
                localStorage.removeItem(key);
            }
        } catch (error) {
            console.warn('Error removing localStorage:', error);
        }
    }
};

const ModalCookie = () => {
    
    const [openModalCookie, toggleModalCookie] = useState(false);
    const [isClient, setIsClient] = useState(false);
    
	const handleClickModalCookie = () => {
        try {
            toggleModalCookie(!openModalCookie);
            localData.set("modalCookieAviso", 'aceito');
        } catch (error) {
            console.warn('Error handling cookie modal:', error);
        }
    };

	useEffect(() => {
        try {
            setIsClient(true);
            const cookieStatus = localData.get("modalCookieAviso");
            if (cookieStatus === 'aceito') {
                toggleModalCookie(true);
            } else if (cookieStatus === null || cookieStatus !== 'aceito') {
                toggleModalCookie(false);
            }
        } catch (error) {
            console.warn('Error in cookie modal effect:', error);
        }
    }, []);

	// Don't render until client-side hydration is complete
	if (!isClient) {
		return null;
	}

	return (
        <div id="modalCookie" className={ openModalCookie ? '' : 'show' }>
            <div className="bodymodal">
                <p>Usamos cookies conforme a nossa <a className="linkcookie" href="/politica-de-privacidade/">Política de Privacidade</a>.</p>
                <button onClick={handleClickModalCookie} id="buttonAceitoCookie" type="button">Aceitar</button>
            </div>
        </div>
	);
};

export default ModalCookie;
